// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutPage_about__114-I","into":"AboutPage_into__34DkM","skill":"AboutPage_skill__16s2x","card__grid":"AboutPage_card__grid__1lznk"};